
// import { useState } from "react";
// import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// import { PropTypes } from "prop-types";

// import {
//   Collapse,
//   NavbarBrand,
//   Navbar,
//   NavItem,
//   NavLink,
//   Nav,
//   Container,
//   Row,
//   Col,
// } from "reactstrap";


// const Sidebar = (props) => {
//   const url = window.location.href;
//   const pathParts = new URL(url).pathname.split('/'); 
//   const cid = pathParts[3]; 
//   const lid = pathParts[4]; 

//   const [collapseOpen, setCollapseOpen] = useState();

//   const toggleCollapse = () => {
//     setCollapseOpen((data) => !data);
//   };
//   const closeCollapse = () => {
//     setCollapseOpen(false);
//   };
//   const createLinks = (routes) => {
//     return routes.map((prop, key) => {
//       if (prop.layout === "/customer") {
//         if (prop.name.toLowerCase() === "foir") {
//             return null;
//         }
//         let path = prop.path;
  
//         if (path) {
//           path = path.replace(":cid", cid).replace(":lid", lid);
//         } else {
//           console.warn('No path defined for route:', prop); 
//         }
  
//         return (
//           <NavItem key={key}>
//             <NavLink to={prop.layout + path} tag={NavLinkRRD} onClick={closeCollapse}>
//               <i className={prop.icon} />
//               {prop.name}
//             </NavLink>
//             {prop.children && prop.children.length > 0 && (
//               <Collapse isOpen={collapseOpen}>
//                 {prop.children.map((child, idx) => {
//                   if (!child.path) {
//                     console.warn('Invalid child route (missing path):', child); 
//                     return null;
//                   }
  
//                   let childPath = child.path
//                     .replace(":cid", cid)
//                     .replace(":lid", lid);
  
//                   return (
//                     <NavItem key={`${key}-${idx}`} className="pl-4">
//                       <NavLink
//                         to={child.layout + childPath}
//                         tag={NavLinkRRD}
//                         onClick={closeCollapse}
//                       >
//                         <i className={child.icon || "fa fa-circle"} />
//                         {child.name}
//                       </NavLink>
//                     </NavItem>
//                   );
//                 })}
//               </Collapse>
//             )}
//           </NavItem>
//         );
//       }
//       return null;
//     });
//   };
  
  

//   const { routes, logo } = props;
//   let navbarBrandProps;
//   if (logo && logo.innerLink) {
//     navbarBrandProps = {
//       to: logo.innerLink,
//       tag: Link,
//     };
//   } else if (logo && logo.outterLink) {
//     navbarBrandProps = {
//       href: logo.outterLink,
//       target: "_blank",
//     };
//   }

//   return (
//     <Navbar
//       className="navbar-vertical fixed-left navbar-light bg-white"
//       expand="md"
//       id="sidenav-main"
//     >
//       <Container fluid>
//         <button
//           className="navbar-toggler"
//           type="button"
//           onClick={toggleCollapse}
//         >
//           <span className="navbar-toggler-icon" />
//         </button>
//         {logo ? (
//           <NavbarBrand className="pt-0" {...navbarBrandProps}>
//             <img
//               alt={logo.imgAlt}
//               className="navbar-brand-img"
//               src={logo.imgSrc}
//             />
//           </NavbarBrand>
//         ) : null}
//         <Collapse navbar isOpen={collapseOpen}>
//           <div className="navbar-collapse-header d-md-none">
//             <Row>
//               {logo ? (
//                 <Col className="collapse-brand" xs="6">
//                   {logo.innerLink ? (
//                     <Link to={logo.innerLink}>
//                       <img alt={logo.imgAlt} src={logo.imgSrc} />
//                     </Link>
//                   ) : (
//                     <a href={logo.outterLink}>
//                       <img alt={logo.imgAlt} src={logo.imgSrc} />
//                     </a>
//                   )}
//                 </Col>
//               ) : null}
//               <Col className="collapse-close" xs="6">
//                 <button
//                   className="navbar-toggler"
//                   type="button"
//                   onClick={toggleCollapse}
//                 >
//                   <span />
//                   <span />
//                 </button>
//               </Col>
//             </Row>
//           </div>
//           <Nav navbar>{createLinks(routes)}</Nav>
//         </Collapse>
//       </Container>
//     </Navbar>
//   );
// };

// Sidebar.defaultProps = {
//   routes: [{}],
// };

// Sidebar.propTypes = {
//   routes: PropTypes.arrayOf(PropTypes.object),
//   logo: PropTypes.shape({
//     innerLink: PropTypes.string,
//     outterLink: PropTypes.string,
//     imgSrc: PropTypes.string.isRequired,
//     imgAlt: PropTypes.string.isRequired,
//   }),
// };

// export default Sidebar;



import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Collapse, NavbarBrand, Navbar, NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";

const Sidebar = (props) => {
  const url = window.location.href;
  const pathParts = new URL(url).pathname.split('/');
  const cid = pathParts[3];
  const lid = pathParts[4];

  const [collapseOpen, setCollapseOpen] = useState(false);
  const [activeSection, setActiveSection] = useState(
    window.location.hash.replace("#", "") || "section-customer"
  );

  const toggleCollapse = () => setCollapseOpen((data) => !data);
  const closeCollapse = () => setCollapseOpen(false);

  // Keep the highlighted item in sync with the section shown (URL hash drives which section renders).
  useEffect(() => {
    const onHash = () =>
      setActiveSection(window.location.hash.replace("#", "") || "section-customer");
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  const getSectionId = (name) => {
    const cleanName = name.toLowerCase().trim();
    if (cleanName === "json") return "section-json";
    if (cleanName === "leads") return "section-leads";
    // Installment & Collection lives inside the Lead card's Installment tab.
    if (cleanName.startsWith("installment")) return "section-leads";
    return `section-${cleanName.replace(/\s+/g, '-')}`;
  };

  // Single-scroll view: scroll to the chosen section (all sections are rendered).
  const handleScroll = (e, name) => {
    e.preventDefault();
    closeCollapse();
    const targetId = getSectionId(name);
    setActiveSection(targetId);
    // Installment & Collection: open the Lead card's Installment tab; Leads opens the Lead tab.
    const cleanName = name.toLowerCase().trim();
    if (cleanName.startsWith("installment")) {
      window.dispatchEvent(new CustomEvent("open-lead-tab", { detail: "installment" }));
    } else if (cleanName === "leads") {
      window.dispatchEvent(new CustomEvent("open-lead-tab", { detail: "lead" }));
    }
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.location.href = `/customer/full-view/${cid}/${lid}#${targetId}`;
    }
  };

  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      // Logic: Show if layout is /customer AND display is not false
      if (prop.layout === "/customer" && prop.display !== false) {
        if (prop.name.toLowerCase() === "foir") return null;

        const sectionId = getSectionId(prop.name);
        const isActive = activeSection === sectionId;

        return (
          <NavItem key={key}>
            <NavLink
              href={`#${sectionId}`}
              onClick={(e) => handleScroll(e, prop.name)}
              className={isActive ? "active font-weight-bold" : ""}
              style={{ 
                cursor: "pointer",
                borderLeft: isActive ? "4px solid #5e72e4" : "4px solid transparent",
                color: isActive ? "#5e72e4" : "#525f7f",
                backgroundColor: isActive ? "rgba(94, 114, 228, 0.08)" : "transparent",
                paddingLeft: "20px",
                transition: "all 0.3s ease"
              }}
            >
              <i className={`${prop.icon} ${isActive ? "text-primary" : ""}`} />
              {prop.name}
            </NavLink>
          </NavItem>
        );
      }
      return null;
    });
  };

  const { routes, logo } = props;
  return (
    <Navbar className="navbar-vertical fixed-left navbar-light bg-white" expand="md" id="sidenav-main">
      <Container fluid>
        <button className="navbar-toggler" type="button" onClick={toggleCollapse}><span className="navbar-toggler-icon" /></button>
        {logo && (
          <NavbarBrand className="pt-0" to={logo.innerLink} tag={Link}>
            <img alt={logo.imgAlt} className="navbar-brand-img" src={logo.imgSrc} />
          </NavbarBrand>
        )}
        <Collapse navbar isOpen={collapseOpen}>
          <Nav navbar>{createLinks(routes)}</Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

export default Sidebar;